import { format as formatFns } from 'date-fns'

/**
 *
 * @param {Object} date
 * @param {number | undefined} date.day - day of the month; 1 - 31 or empty
 * @param {number | undefined} date.month - month of the year; 1 - 12 or empty
 * @param {number} date.year - year - 4 digits
 * @returns Date in ISO format and set to UTC (not local time)
 */
export const getDate = function ({ day, month, year }) {
  if (!year) return ''

  let formattedDate = new Date()
  formattedDate.setFullYear(year)

  if (NotEmpty(month) && NotEmpty(day)) { // month and day
    formattedDate.setMonth(month - 1)
    formattedDate.setDate(day)
  } else if (NotEmpty(month)) { // month present; day absent
    formattedDate.setMonth(month - 1)
    formattedDate.setDate(1)
  } else if (NotEmpty(day)) { // month absent; day present
    formattedDate.setMonth(0)
    formattedDate.setDate(day)
  } else { // both absent
    formattedDate.setMonth(0)
    formattedDate.setDate(1)
  }

  formattedDate.setHours(0)
  formattedDate.setMinutes(0)

  return formattedDate
}

const NotEmpty = function (value) {
  return value !== null && value !== '' && value !== undefined
}

export const randomFromInterval = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

const isNumber = param => typeof param === 'number'

const validMonth = month => isNumber(month) && (month > 0 && month < 13)

const validYear = year => isNumber(year) && year.toString().length === 4

const validDay = day => isNumber(day) && (day > 0 && day < 32)

/**
 *
 * @param {Object} date
 * @param {number | undefined} date.day - day of the month; 1 - 31 or empty
 * @param {number | undefined} date.month - month of the year; 1 - 12 or empty
 * @param {number} date.year - year - 4 digits
 * @returns Date as a string in yyyy, MM, yyyy or MM d, yyyy formats
 */
export const getDateString = function ({ day, month, year }) {

  if (!year || !validYear(year)) return ''

  // month and day could be zero
  if (NotEmpty(month) && !validMonth(month)) return ''
  if (NotEmpty(day) && !validDay(day)) return ''


  let startDate = new Date()
  startDate.setFullYear(year)

  if (NotEmpty(month) && NotEmpty(day)) {
    startDate.setMonth(month - 1) // month in date object uses zero-based indexing
    startDate.setDate(day)
    startDate = formatFns(startDate, 'MMM d, yyyy')
  } else if (NotEmpty(month) && NotEmpty(day) === false) {
    startDate.setMonth(month - 1)
    startDate = formatFns(startDate, 'MMM, yyyy')
  } else if (NotEmpty(year)) {
    startDate = startDate.getFullYear() // Will provide defaults for month and day without the call to getFullYear()
  }


  return startDate.toString()
}